import type { ReactNode } from 'react';
import { TriangleAlertIcon } from 'lucide-react';

import { Card, CardDescription, CardHeader } from '@/components/ui/card';
import { TabTable } from './TabTable';

export interface UngroupedTabsCardProps {
  tabCount: number;
  /** グループ未指定のタブの行（`TabRow`）。 */
  children: ReactNode;
}

/** グループ未指定のタブ（閲覧画面に出ない）をまとめるカード。要対応の状態なので注意の色で示す。 */
export function UngroupedTabsCard({ tabCount, children }: UngroupedTabsCardProps) {
  return (
    <Card
      role="region"
      aria-label="グループ未指定のタブ"
      className="overflow-hidden border-dashed border-warning/40 shadow-none"
    >
      <CardHeader className="flex-row items-start gap-2.5 space-y-0 px-5 py-3.5">
        <TriangleAlertIcon size={16} className="mt-0.5 shrink-0 text-warning" aria-label="警告" />
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <h2 className="text-[15px] font-semibold">グループ未指定</h2>
            <span className="whitespace-nowrap rounded-full bg-muted px-2.5 py-0.5 text-xs font-semibold text-muted-foreground">
              {tabCount} タブ
            </span>
          </div>
          <CardDescription>
            {tabCount}{' '}
            件のタブが閲覧画面に表示されていません。「グループへ移動」でタブグループを選んでください。
          </CardDescription>
        </div>
      </CardHeader>
      <TabTable ariaLabel="グループ未指定のタブ" showOrder={false}>
        {children}
      </TabTable>
    </Card>
  );
}
